import React from 'react'
import { Link } from 'react-router-dom'
import { Heading } from '@myxplor/ui'

const NoProviderRegistrations = ({ newPath }) => (
  <div>
    <Heading small>No CCS Provider Registrations</Heading>
    <p>
      Would you like to <Link to={newPath}>add your Provider Registration now?</Link>
    </p>
  </div >
)

export default NoProviderRegistrations



// WEBPACK FOOTER //
// ./src/providers-registrations/views/empty.jsx